import React from 'react';
import { Box, Typography } from '@mui/material';

const PlaceholderImg = ({ img, text }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%", // fixed width, can make it responsive with "100%"
        // display: "inline-block",
      }}
    >
      {/* Actual image */}
      <Box
        component="img"
        src={img}
        alt={text}
        sx={{
          width: "100%",
          height: "auto",   // 👈 keeps natural aspect ratio
          display: "block",
          opacity: 0.3,     // 👈 opacity only on image
        }}
      />

      {/* Overlay text */}
      <Typography
        variant="body2"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "blue.main",
          fontWeight: "bold",
          textAlign: "center",
          
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default PlaceholderImg;
